import React, { Component } from 'react'
import "./NavbarTop.scss"
import logo from "../../assets/images/logo.png"
import {BarChartOutlined} from '@ant-design/icons';

class NavbarTop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            navStatus: true
        }
    }

    render() {
        return (
            <div className="navbartop-main">
                {/* <div className="navbartop-sidenav-icon" onClick={()=>{
                    if(this.state.navStatus){
                        this.setState({navStatus:false});
                        this.props.sidenavChange(false)
                    }else{
                        this.setState({navStatus:true})
                        this.props.sidenavChange(true)

                }}}>
                    {(this.state.navStatus?<icon className="fa fa-bars"/>:<icon className="fa fa-ellipsis-v"/>)}
                </div> */}
                <div className="navbartop-header" style={{ padding: 8, width: "100%", display: "flex", flexDirection: "row", justifyContent: "left" }}>
                    <div style={{ width: 50 }}>
                        <img src={logo} style={{ height: 20, width: 20 }} />
                    </div>
                    <div>
                        <h5>ProTime</h5>
                    </div>
                     <a
                        href="https://app.powerbi.com/groups/me/reports/d93ede7a-0c60-446a-af45-0e2baa57983d/18579690730d90680b00?ctid=97424943-93ed-421f-81ce-f245fd53a717&experience=power-bi"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: "flex", alignItems: "center", color: "#ffffff", marginLeft: '80%'}}
                        title="View Power BI Report"
                        >
                        <BarChartOutlined style={{ fontSize: "18px", marginRight: "5px" }} />
                        <span style={{ fontSize: "14px" }}>PowerBI Dashboard</span>
                     </a>
                </div>
            </div>
        )
    }
}

export default NavbarTop;